{
  "title": "Earthbind",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "300 feet",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Choose one creature you can see within range. Yellow strips of magical energy loop around the creature. The target must succeed on a Strength saving throw or its flying speed (if any) is reduced to 0 feet for the spell’s duration. An airborne creature affected by this spell descends at 60 feet per round until it reaches the ground or the spell ends."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
